import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            const res = await api.post("/newsletter", { email });
            toast.success(
                res.data.already_subscribed
                    ? "You're already on the list."
                    : "Welcome to the inner circle."
            );
            setEmail("");
        } catch (err) {
            toast.error("Subscription failed. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer
            id="contact"
            data-testid="footer"
            className="bg-black border-t border-white/10 relative"
        >
            <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <p className="label-mono">Inner Circle</p>
                    <h3 className="font-display text-4xl md:text-6xl uppercase tracking-tight leading-[0.9] mt-4 mb-8">
                        Join the
                        <br /> next drop.
                    </h3>
                    <form
                        onSubmit={onSubscribe}
                        className="flex border-b border-white/30 focus-within:border-white max-w-md"
                        data-testid="newsletter-form"
                    >
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your@email.com"
                            data-testid="newsletter-email-input"
                            className="bg-transparent flex-1 py-3 outline-none placeholder:text-muted-foreground/50 font-sans"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="newsletter-submit"
                            className="font-mono text-xs uppercase tracking-[0.25em] px-4 disabled:opacity-50"
                        >
                            {loading ? "..." : "→ Submit"}
                        </button>
                    </form>
                </div>

                <div className="md:col-span-3">
                    <p className="label-mono">Navigate</p>
                    <ul className="mt-4 space-y-2 font-sans text-sm">
                        <li><a href="#shop" className="hover:text-white text-muted-foreground">Shop</a></li>
                        <li><a href="#worn" className="hover:text-white text-muted-foreground">Worn</a></li>
                        <li><a href="#story" className="hover:text-white text-muted-foreground">Story</a></li>
                        <li><Link to="/admin" className="hover:text-white text-muted-foreground">Admin</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="label-mono">Reach</p>
                    <p className="font-display text-2xl mt-4 leading-tight">
                        sales@wwwenergymatcher.com
                        <br />
                        <span className="text-muted-foreground text-xl">Mon–Fri · 9–6</span>
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mt-3">
                        wwwenergymatcher.com
                    </p>
                    <div className="mt-6 flex gap-4">
                        <a href="#" className="p-2 border border-white/20 hover:border-white" data-testid="social-instagram"><Instagram size={16} /></a>
                        <a href="#" className="p-2 border border-white/20 hover:border-white" data-testid="social-twitter"><Twitter size={16} /></a>
                        <a href="#" className="p-2 border border-white/20 hover:border-white" data-testid="social-youtube"><Youtube size={16} /></a>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                        © {new Date().getFullYear()} Energy Matcher — All rights reserved.
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                        Made for those who move with purpose
                    </p>
                </div>
            </div>
        </footer>
    );
}
